import { useIntl } from 'react-intl';

import type { ChargingDetails } from '#domain/ChargingDetails.ts';

export const ChargingDetailsView = ({ value }: { value: ChargingDetails }) => {
    const intl = useIntl();
    const config = value.configuration;
    const estimate = value.estimate;
    return (
        <div className='padding-10 margin-top-10 border rounded bg-lightest'>
            <div>
                {intl.formatMessage(
                    {
                        id: `intl-msg:ordercom-cloud-frontend.charging.${config.mode === 'target_percentage' ? 'target-value' : 'duration-value'}`,
                    },
                    {
                        value:
                            config.mode === 'target_percentage'
                                ? intl.formatNumber(Math.max(0.1, config.target_percentage ?? 0) / 100, {
                                      style: 'percent',
                                      maximumFractionDigits: 1,
                                  })
                                : intl.formatNumber(config.charging_duration_seconds ?? 0),
                    }
                )}
            </div>
            {estimate && (
                <>
                    <div>
                        {intl.formatMessage(
                            { id: 'intl-msg:ordercom-cloud-frontend.charging.snapshot' },
                            {
                                arrival: Math.round(
                                    (estimate.arrival_charge_kwh / estimate.battery_capacity_kwh) * 100
                                ),
                                departure: Math.round(
                                    (estimate.departure_charge_kwh / estimate.battery_capacity_kwh) * 100
                                ),
                                minutes: Math.ceil((estimate.charging_seconds + estimate.setup_seconds) / 60),
                            }
                        )}
                    </div>
                    <small>{intl.formatMessage({ id: 'intl-msg:ordercom-cloud-frontend.charging.historical' })}</small>
                </>
            )}
        </div>
    );
};
